// Horizontal padding for the <main> content wrapper.
//
// The nav chrome (MainNav / SubNav pills) and the BottomBar are inset 10px
// from the screen edges (mx-2.5 / left-2.5 right-2.5). EVERY page aligns its
// content to that same 10px inset so cards and tables line up flush with the
// nav pills above them — Home and Analytics first, extended to the document
// detail pages (and everything else) on request. The route parameter stays so
// a future page can opt into different padding without re-plumbing AppLayout.
export function mainPadding(_pathname: string): string {
  return 'px-2.5';
}
